<div #txt class="txt" [innerHTML]="content"></div>